/**
 * Skeleton theme constants — reads CSS variables at runtime so they
 * automatically follow the active app theme (light / dark / indigo / etc.)
 *
 * Usage:
 *   import { getSkeletonColors } from '../constants/skeletonTheme';
 *   const { baseColor, highlightColor } = getSkeletonColors();
 */

/**
 * Reads the current CSS-variable values from the document root.
 * Falls back to sensible defaults so skeletons render even before
 * the ThemeProvider has mounted.
 */
export function getSkeletonColors(theme) {
    if (theme === 'dark') {
        return {
            baseColor: '#1C1C1C',      // --surface-2
            highlightColor: '#2A2A2A', // --border shimmer
            bg: '#141414'              // --surface
        };
    }
    // Default Light Mode (Warm Paper)
    return {
        baseColor: '#EFE9DD',      // --surface-2
        highlightColor: '#FDFBF7', // warm paper shimmer
        bg: '#FFFFFF'              // --surface
    };
}

/** Duration of the shimmer animation in seconds */
export const SKELETON_DURATION = 1.4;

/** Border-radius used across all skeleton shapes */
export const SKELETON_RADIUS = {
    sm:   '4px',
    md:   '8px',
    lg:   '12px',
    full: '9999px',
};
